import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Stagger, StaggerItem } from "@/components/motion";
import SectionHeader from "@/components/SectionHeader";
import { SERVICES } from "@/data/site";

export default function ServicesGrid({ limit, showHeader = true }) {
  const items = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <section className="dq-container py-20 lg:py-28" data-testid="services-section" id="services">
      {showHeader && (
        <div className="mb-14 flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeader
            eyebrow="What we do"
            title="Premium services built to"
            highlight="grow your business"
            subtitle="Everything you need to get found, get trusted and get chosen online — under one roof."
          />
          <Link to="/services" data-testid="services-view-all" className="btn-secondary shrink-0">
            View all services <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      )}

      <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {items.map((s) => (
          <StaggerItem key={s.slug}>
            <div className="group h-full rounded-3xl border border-dq-line bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-2 hover:border-dq-orange/30 hover:dq-shadow-soft"
              data-testid={`service-card-${s.slug}`}>
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-dq-orange/10 text-dq-orange transition-transform duration-300 group-hover:scale-110">
                <s.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-dq-ink">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-dq-muted">{s.desc}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
